import styles from '@components/common/products/product.styles';
import { Rating, ThinStar } from "@smastrom/react-rating";
import { useProductsRating } from '@v2/store/rtk.stamped.selectors';
import colors from '@v2/styles/colors';
import { useRef } from 'react';
import { useIsMobile } from '../../helpers/screen-check';

const ratingStyles = {
    itemShapes: ThinStar,
    itemStrokeWidth: 2,
    activeFillColor: colors.RED,
    activeStrokeColor: colors.RED,
    inactiveFillColor: 'transparent',
    inactiveStrokeColor: colors.RED
}

const REVIEWS = [
    {
        review: `We love this food for our 2 year old with special needs.
            He's been eating it since he started solids at 6 months.
            He's a good eater and loves the different flavors. He seems more willing to try a variety of
            foods and flavors compared to my daughter that did not eat this. And best of all I know he's getting the nutrients
            and no junk in his food for his brain to develop.`,
        owner: 'Amanda T.'
    },
    {
        review: `My son loves these pouches and knowing they are so nutritious and beneficial
            for his brain development makes them that much better!`,
        owner: 'Katelyn M.'
    },
    {
        review: `My kids love these pouches so much!!`,
        owner: 'Justine B.'
    },
    {
        review: `Even though we're moving away from purees,
            keeping the cerebelly pouches and now snack bars in the rotation works wonderfully for us.`,
        owner: 'Suzanne H.'
    },
    {
        review: `We love the Cerebelly pouches for our infant and toddler.
            Great simple ingredients, the kids love them, and they have a recycling program`,
        owner: 'Matthew L.'
    },
    {
        review: `Sometimes it’s hard for me to get my toddler to eat enough nutrient dense food everyday.
            I use cerebelly pouches to supplement, and not only does my toddler thoroughly enjoy the flavors,
            but I trust that she’s consuming raw tested foods with these pouches.`,
        owner: 'Cecilia A.'
    },
    {
        review: `My little one loves the pouches and bars. It’s a great feeling to know
            I can give them to him worry free because they are actually clean. I recommend this amazing product.`,
        owner: 'Christina B.'
    },
    {
        review: `Our little one loves these pouches and give us a peace of mind of all the nutrients he’s receiving!`,
        owner: 'Cheyenne W.'
    },
    {
        review: `My 1 year old loves it! When I’m in a rush, traveling, or need a separate food option for my little guy,
            I like to give him a pouch and my little guy is happy to eat it.
            It is nice to have a healthy option and know that I’m providing my child with the nutrients he needs.`,
        owner: 'Tinique C.'
    },
]

export default function ProductRatings() {

    const isMobile = useIsMobile(599);
    const { rating, total } = useProductsRating();
    const randomReviewIndex = useRef<number>(Math.floor(Math.random() * REVIEWS.length));

    return (
        <div className={styles.ratings}>
            <h3>LITTLE ONES LOVE US</h3>
            <h2>reviews</h2>
            <div className='container-product-ratings'>
                {!isMobile ?
                <>
                    <div className='left-section'>
                        <div className='rating-container'>
                            <div className='rating-value'>{rating.toFixed(1)}</div>
                            <Rating
                                value={rating}
                                readOnly
                                className="rating"
                                itemStyles={ratingStyles}/>
                        </div>
                        <div className='total-value'>{total.toLocaleString()} Reviews</div>
                        <a tabIndex={0} href="/reviews" target="_blank" className="button blue read-reviews-button" aria-label="READ REVIEWS">
                            READ REVIEWS
                        </a>
                    </div>
                    <div className='right-section'>
                        <Rating
                            value={5}
                            readOnly
                            className="rating"
                            itemStyles={ratingStyles} />
                        <div className='review'>“{REVIEWS[randomReviewIndex.current].review}”</div>
                        <div className='owner'>{REVIEWS[randomReviewIndex.current].owner}</div>
                    </div>
                </> :
                <div className='container-product-ratings'>
                    <div className='right-section'>
                        <Rating
                            value={5}
                            readOnly
                            className="rating"
                            itemStyles={ratingStyles} />
                        <div className='review'>“{REVIEWS[randomReviewIndex.current].review}”</div>
                        <div className='owner'>{REVIEWS[randomReviewIndex.current].owner}</div>
                    </div>
                    <a tabIndex={0} href="/reviews" target="_blank" className="button blue read-reviews-button" aria-label="READ REVIEWS">
                        READ REVIEWS
                    </a>
                </div>
                }
            </div>
        </div>
    );
}
